export const currencyFormatSek = (num: number) =>
  num
    .toFixed(2) // always two decimal digits
    .replace('.', ',') // replace decimal point character with ,
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' kr'; // use . as a separator
